<template>
	<div class="details-header">
		<div class="back-button">
			<Button
				link
				:to="{ name: 'integrations', params: { type: 'CONNECTED' } }"
			>
				<ChevronIcon type="regular" left />
				<span v-t="'Integrations'" />
			</Button>
		</div>

		<div class="logo-title-container">
			<div class="logo-title">
				<div class="logo">
					<img :src="logoUrl" />
				</div>
				<div class="title" v-text="fullTitle" />
			</div>
			<div class="right-container">
				<slot name="right-controls" />
			</div>
		</div>

		<div class="status-container">
			<slot name="status" />
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import { Button } from '@/components/common'
import { ChevronIcon } from '@/icons'

// Props
const props = defineProps({
	logoUrl: {
		type: String,
		required: true,
	},
	title: {
		type: String,
		required: true,
	},
})

const emit = defineEmits(['back'])
const fullTitle = computed(() => {
	return `${props.title} Setup`
})
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.details-header {
	min-height: 90px;
	background-color: #f9f9f9;
	padding: 15px 35px;
	border-bottom: solid 1px var(--neutral-200);

	.back-button {
		margin-bottom: 5px;

		.pronto-btn {
			font-size: 14px;
			padding: 0;
		}
	}

	.logo-title-container {
		display: flex;
		align-items: center;
		justify-content: space-between;

		.logo-title {
			display: flex;
			align-items: center;

			.title {
				font-size: 36px;
				color: var(--neutral-800);
				margin-left: 7px;
				font-family: 'Avenir-Heavy';
			}

			.logo {
				height: 65px;
				width: 65px;
				border: solid 1px var(--neutral-200);
				padding: 2.5px;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 6.5px;
				img {
					height: 100%;
					width: 100%;
					border-radius: 6.5px;
				}
			}
		}
	}
}
</style>
